import { useQuery, gql } from "@apollo/client"
import { USER_TRAINING_COURSE_LIST_FIELDS } from "./fragments/userTrainingFragments"

export const USER_TRAINING_COURSES_QUERY = gql`
  query UserTrainingCourses {
    userTrainingCourses {
      ...UserTrainingCourseListFields
    }
  }
  ${USER_TRAINING_COURSE_LIST_FIELDS}
`

export const userTrainingCoursesTypePolicies = {
  scoped: {
    UserTrainingModuleStatus: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      }
    }
  }
}

export const useQueryUserTrainingCourses = (variables = {}, options = {}) => {
  return useQuery(USER_TRAINING_COURSES_QUERY, {
    variables,
    ...options,
    fetchPolicy: "network-only",
    context: {
      serializationKey: "user-training-courses"
    }
  })
}
